import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Loader2, Mail, Phone, Globe, Users, Building2, Tag } from "lucide-react";

export default function AdminLeads() {
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => setLeads([]));
  }, []);

  if (leads === null) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin" style={{ color: "#B08D57" }} /></div>;

  return (
    <div data-testid="admin-leads">
      <h2 className="font-heading text-2xl mb-6">Consultation Enquiries <span className="text-sm font-body" style={{ color: "#6B7280" }}>({leads.length})</span></h2>
      {leads.length === 0 ? (
        <p className="text-sm" style={{ color: "#6B7280" }}>No enquiries yet.</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {leads.map((l) => (
            <div key={l.lead_id} data-testid={`lead-${l.lead_id}`} className="rounded-2xl border p-5 bg-white" style={{ borderColor: "#E5E7EB" }}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-heading text-xl">{l.name}</p>
                  <p className="text-xs mt-0.5" style={{ color: "#6B7280" }}>{new Date(l.created_at).toLocaleString()}</p>
                </div>
                {l.preferred_retreat && <span className="text-[10px] uppercase tracking-wider px-3 py-1 rounded-full" style={{ background: "#F1E9DC", color: "#8A6A2F" }}>{l.preferred_retreat}</span>}
              </div>
              <div className="mt-3 space-y-1.5 text-sm" style={{ color: "#374151" }}>
                {l.inquiry_type && <p className="flex items-center gap-2"><Tag className="w-3.5 h-3.5" /> {l.inquiry_type}</p>}
                {l.company && <p className="flex items-center gap-2"><Building2 className="w-3.5 h-3.5" /> {l.company}</p>}
                {l.email && <p className="flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> {l.email}</p>}
                {l.phone && <p className="flex items-center gap-2"><Phone className="w-3.5 h-3.5" /> {l.phone}</p>}
                {l.country && <p className="flex items-center gap-2"><Globe className="w-3.5 h-3.5" /> {l.country}{l.locale ? ` · ${l.locale}` : ""}</p>}
                {(l.guests || l.preferred_month) && <p className="flex items-center gap-2"><Users className="w-3.5 h-3.5" /> {l.guests || "?"} guests · {l.preferred_month || "month TBC"}</p>}
                {l.health_goals && <p className="pt-2" style={{ color: "#6B7280" }}>{l.health_goals}</p>}
                {l.message && <p className="pt-2" style={{ color: "#6B7280" }}>{l.message}</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
